import type { Processor } from 'unified';
import type { Extension as FromMarkdownExtension } from 'mdast-util-from-markdown';
import type { Options as ToMarkdownExtension } from 'mdast-util-to-markdown';
import type { Extension as MicromarkExtension } from 'micromark-util-types';

import { mathFromMarkdown, mathToMarkdown } from '../mdast-util-math/index.js';
import { math } from '../micromark-extension-math/index.js';
import type { Options } from '../types.js';

const emptyOptions: Readonly<Options> = {};

type MathProcessorData = {
  fromMarkdownExtensions?: FromMarkdownExtension[];
  micromarkExtensions?: MicromarkExtension[];
  toMarkdownExtensions?: ToMarkdownExtension[];
};

/**
 * Register BlockSuite's Markdown math syntax with a unified processor.
 *
 * The emitted nodes are the standard mdast `inlineMath` and `math` nodes, so
 * consumers remain compatible with the broader unified ecosystem.
 */
export default function remarkMath(
  this: Processor,
  options?: Readonly<Options> | null
): undefined {
  const settings = options ?? emptyOptions;
  const data = this.data() as MathProcessorData;
  const micromarkExtensions = (data.micromarkExtensions ??= []);
  const fromMarkdownExtensions = (data.fromMarkdownExtensions ??= []);
  const toMarkdownExtensions = (data.toMarkdownExtensions ??= []);

  micromarkExtensions.push(math(settings));
  fromMarkdownExtensions.push(mathFromMarkdown(settings));
  toMarkdownExtensions.push(mathToMarkdown(settings));
}
